import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    cardContainer: {
        justifyContent: "space-between",
        flexDirection: "column",
        overflow: "hidden",
        display: "flex",
        height: "100%",
        width: "100%",
        flex: 1,
        ...webStyle({
            transition: "all 0.2s ease",
            cursor: "pointer"
        })
    },
    cardFooter: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        marginTop: "auto",
        width: "100%"
    },
    cardBody: {
        justifyContent: "space-between",
        flexDirection: "column",
        display: "flex",
        width: "100%",
        flex: 1
    },
    gridContainer: {
        justifyContent: "flex-start",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    avatarBadge: {
        justifyContent: "center",
        alignItems: "center",
        height: 48,
        width: 48
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    paginationContainer: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    },
    cardInstagramButton: {
        justifyContent: "center",
        position: "absolute",
        alignItems: "center",
        cursor: "pointer",
        height: 36,
        zIndex: 10,
        width: 36
    },
    cardWrapper: {
        flexDirection: "column",
        display: "flex",
        flexBasis: 320,
        flexShrink: 1,
        flexGrow: 0
    },
    cardTopRightBadges: {
        alignItems: "flex-end",
        position: "absolute"
    },
    headerActions: {
        alignItems: "center",
        flexDirection: "row"
    },
    filterSection: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    cardBanner: {
        position: "relative",
        aspectRatio: 16 / 9,
        maxHeight: 180,
        width: "100%"
    },
    cardBadgeContainer: {
        position: "absolute",
        bottom: -24,
        left: 16
    },
    avatarBadgeText: {
        textAlign: "center"
    },
    emptyText: {
        textAlign: "center"
    },
    bannerImage: {
        height: "100%",
        width: "100%"
    },
    cardDescription: {
        lineHeight: 20,
        minHeight: 40,
        width: "100%"
    },
    searchContainer: {
        minWidth: 250,
        flex: 1
    },
    cardTitle: {
        minHeight: 48,
        width: "100%"
    },
    cardContentTop: {
        width: "100%"
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
